import { extractDateOnly } from '@/lib/date-utils';

type QuotationDates = {
  startDate?: string | Date | null;
  endDate?: string | Date | null;
  tripId?: string | null;
};

type TripDates = {
  start_date?: string | null;
  end_date?: string | null;
};

/**
 * Datas exibidas na capa da visualização do cliente.
 * Com viagem vinculada, prioriza as datas da viagem (período da viagem).
 */
export function resolveCoverDates(
  quotation: QuotationDates,
  trip?: TripDates | null
): { startDate: string | null; endDate: string | null } {
  const quotationStart = extractDateOnly(quotation.startDate ?? null);
  const quotationEnd = extractDateOnly(quotation.endDate ?? null);

  if (quotation.tripId && trip) {
    const tripStart = extractDateOnly(trip.start_date ?? null);
    const tripEnd = extractDateOnly(trip.end_date ?? null);
    if (tripStart || tripEnd) {
      return { startDate: tripStart, endDate: tripEnd };
    }
  }

  return { startDate: quotationStart, endDate: quotationEnd };
}

export function mapQuotationDatesFromDb(
  startDate?: string | null,
  endDate?: string | null
): { startDate: string | null; endDate: string | null } {
  return {
    startDate: extractDateOnly(startDate ?? null),
    endDate: extractDateOnly(endDate ?? null),
  };
}
